import { NotifyMeButton } from "@/components/waitlist/NotifyMeButton";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const providers = [
  { key: 'amazon', label: 'Amazon' },
  { key: 'ebay', label: 'eBay' },
  { key: 'walmart', label: 'Walmart' },
  { key: 'pinterest', label: 'Pinterest' },
  { key: 'facebook', label: 'Facebook Shops' },
  { key: 'tiktok', label: 'TikTok Shop' },
];

export const MarketplaceIntegrationsCard = () => {
  const isLoading = false;

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Intégrations Marketplace</CardTitle>
        <CardDescription>Connectez vos canaux de vente pour synchroniser produits et commandes.</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="grid gap-3 md:grid-cols-3">
            {Array.from({ length: 6 }).map((_,i) => (
              <div key={i} className="h-16 animate-pulse rounded-md bg-muted" />
            ))}
          </div>
        ) : (
          <div className="grid gap-3 md:grid-cols-3">
            {providers.map(p => {
              
              return (
                <div key={p.key} className="flex flex-wrap items-center justify-between gap-3 rounded-md border p-3">
                  <div>
                    <div className="font-medium">{p.label}</div>
                    
                  </div>
                  <div className="flex flex-wrap gap-2"><Button size="sm" variant="outline" disabled>Bientôt disponible</Button><NotifyMeButton channel={p.key} size="sm" /></div>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
